import { render } from "./MyCounter.vue?vue&type=template&id=5cfe66da"
import script from "./MyCounter.vue?vue&type=script&lang=js"
export * from "./MyCounter.vue?vue&type=script&lang=js"

import exportComponent from "E:\\OpenServer\\domains\\vue\\vue-catalog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__